<div [class.borderless]="!withBorder" class="ui icon right floated dropdown basic button">
    <img appIcon="MeatballSolid" />
    <div class="left menu">
        <ng-content></ng-content>
    </div>
</div>
